import { app } from '../../../bootstrap/core';
import { sidebarComponent } from './sidebar.component';
import { SidebarService } from './sidebar.service';
import './section/sidebarSection';

app.component('sidebar', sidebarComponent);
app.service('sidebarService', SidebarService);
